module.exports = __webpack_public_path__ + "static/img/chui.25a57c6.gif";


//////////////////
// WEBPACK FOOTER
// ./static/img/chui.gif
// module id = 0Ael
// module chunks = 4